import { onReject } from 'common/utils/Bugsnag';
import React from 'react';
import PriorityImageDownloader from './PriorityImageDownloader';

const downloader = new PriorityImageDownloader(15);

interface Props extends React.ImgHTMLAttributes<HTMLImageElement> {
    src: string;
    preload: boolean;
}

interface State {
    isLoaded: boolean;
}

class Img extends React.Component<Props, State> {
    state = {
        isLoaded: false,
    };

    constructor(props: Props) {
        super(props);

        let promise;
        if (!props.preload) {
            promise = downloader.downloadNow(props.src);
        } else {
            promise = downloader.downloadWithPriority(props.src, 1);
        }

        if (promise) {
            promise.then(() => this.setState({ isLoaded: true }), onReject('Img Component'));
        } else {
            this.state.isLoaded = true;
        }
    }

    render() {
        const { preload, ...props } = this.props;
        return this.state.isLoaded ? <img {...props} /> : null;
    }
}

export default Img;
